import { render, staticRenderFns } from "./SupplierConcepts.vue?vue&type=template&id=52c5a9d1&scoped=true&lang=pug&"
import script from "./SupplierConcepts.vue?vue&type=script&lang=js&"
export * from "./SupplierConcepts.vue?vue&type=script&lang=js&"
import style0 from "./SupplierConcepts.vue?vue&type=style&index=0&id=52c5a9d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5a9d1",
  null
  
)

export default component.exports